export default __webpack_public_path__ + "static/bg-ai-solution-with-roadmap--mobile-ddb11be568ce554fd224258a05d801f4.webp";